import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class Comment extends Base implements EntityType {
    commentId: uuid;
    note: string;
    sourceType?: string | null;
    sourceLabel?: string | null;
    constructor(doc: typeof Comment | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            commentId: genUUID(),
            note: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "comment";
        // @ts-ignore
        this.commentId = doc._commentId || doc.commentId || doc.commentid || genUUID();
        // @ts-ignore
        this.note = doc._note || doc.note || null;
        // @ts-ignore
        this.sourceType = doc._sourceType || doc.sourceType || doc.sourcetype || null;
        // @ts-ignore
        this.sourceLabel = doc._sourceLabel || doc.sourceLabel || doc.sourcelabel || null;
    }
    get id(): uuid { return this.commentId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for comment"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.commentId; }
    displayFn() { return this.note; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Comment[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'comment',
    table: 'COMMENT',
    comment: 'A free-text note that a firm user can attach to any entity (matter, lead, contact, task, campaign). Comments are timestamped, attributed to the adding user, and displayed in a threaded feed on the parent entity. When viewed from a matter or lead, comments from related tasks and contacts are aggregated into the same feed for full context.',
    fields: {
        commentId: {type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for comment'},
        note: {type: 'string', required: true, comment: 'The actual comment'},
        sourceType: {type: 'string', transient: true, comment: 'What type of entity did this come from?'},
        sourceLabel: {type: 'string', transient: true, comment: 'A text label for the source of this comment'}
    },
    displayFn: 'this.note',
    maps: [
        {
            name: 'entityId',
            keysFn: m => m.entityId,
            presentFn: (m, k) => m.entityId === k && m.status !== 'D'
        },
    ]
});
    }
}
export default Comment;
